import {
    Grid,
    Box,
    Typography,
    TextField,
} from "@material-ui/core";
import useStyles from "../../assets/styles/styles";



const VitalSignInput = ({ label, value, onChange, error, errorMessage, unit }) => {

    const classes = useStyles();

    return (
        <Grid item xs={12} md={6}>
            <Box display="flex" alignItems="center" gap={2}>
                <Typography className={classes.txtDescriptionVitalSignsForm}>{label}</Typography>
                <Box display="flex" flexDirection="column">
                    <Box display="flex" alignItems="center" gap={1}>
                        <TextField
                            value={value}
                            onChange={onChange}
                            variant="outlined"
                            error={!!error}
                        />
                        <Typography className={classes.txtDescriptionVitalSignsForm}>{unit}</Typography>
                    </Box>
                    {error && (
                        <Typography variant="body2" color="error" className={classes.txtDescriptionVitalSignsError}>
                            {errorMessage}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Grid>
    );
};

export default VitalSignInput;